import styled from 'styled-components';

export const ConfirmationContent = styled.div`
  margin: auto;
  max-width: 600px;
`;
